import { Box, FormLabel, Stack, Typography } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { DATE_FORMAT, SubSection } from '@ui-framework/index';
import dayjs from 'dayjs';
import ClaimStatus from '../../../ClaimStatus';
import UnPaginatedList from '../../../UnPaginatedList';

// create component which accepts user object  having first name and last name, and displays full name
function FullName({ user }) {
  return <span>{`${user.firstName} ${user.lastName}`}</span>;
}

function ClaimDetail({ claimData }) {
  const { createdDateTime, claimStatus, claimNumber } = claimData;
  // Only show one: reject reason takes precedence over approve override
  const renderReason = () => {
    if (claimStatus === 'REJECTED' || claimStatus === 'REJECTED_OVERRIDE') {
      return (
        <Grid2 container>
          <Grid2 xs={12} md={3}>
            <FormLabel>Claim Rejected Date</FormLabel>
            <Box>
              <Typography
                color="common.black"
                fontWeight="bold"
                variant="body2">
                {claimData.rejectedDateTime
                  ? dayjs(claimData.rejectedDateTime).format(
                      DATE_FORMAT.LONG_DATE,
                    )
                  : '-'}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 xs={12} md={3}>
            <FormLabel>Rejected By</FormLabel>
            <Box>
              <Typography
                color="common.black"
                fontWeight="bold"
                variant="body2">
                <FullName user={claimData.rejectedByUser} />
              </Typography>
            </Box>
          </Grid2>
          <Grid2 xs={12} md={6}>
            <FormLabel>Reject Reason</FormLabel>
            <Box>
              <Typography
                color="common.black"
                fontWeight="bold"
                variant="body2">
                {claimData.rejectReasonCode
                  ? `${claimData.rejectReasonCode} - ${claimData.rejectReasonText}`
                  : '-'}
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
      );
    }
    if (claimStatus === 'APPROVED' || claimStatus === 'APPROVED_OVERRIDE') {
      return (
        <Grid2 container>
          <Grid2 xs={12} md={3}>
            <FormLabel>Claim Approved Date</FormLabel>
            <Box>
              <Typography
                color="common.black"
                fontWeight="bold"
                variant="body2">
                {claimData.approvedDateTime
                  ? dayjs(claimData.approvedDateTime).format(
                      DATE_FORMAT.LONG_DATE,
                    )
                  : '-'}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 xs={12} md={3}>
            <FormLabel>Approved By</FormLabel>
            <Box>
              <Typography
                color="common.black"
                fontWeight="bold"
                variant="body2">
                <FullName user={claimData.approvedByUser} />
              </Typography>
            </Box>
          </Grid2>

          <Grid2 xs={12} md={3}>
            <FormLabel>Approved Override Reason</FormLabel>
            <Box>
              <Typography
                color="common.black"
                fontWeight="bold"
                variant="body2">
                {claimData.approveOverrideCode} -{' '}
                {claimData.approveOverrideText}
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
      );
    }
    return null;
  };

  return (
    <Stack spacing={1}>
      <SubSection>
        <Grid2 container>
          <Grid2 xs={12} md={3}>
            <FormLabel>Claim Number</FormLabel>
            <Box>
              <Typography
                color="common.black"
                fontWeight="bold"
                variant="body2">
                {claimNumber}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 xs={12} md={3}>
            <FormLabel>Claim Status</FormLabel>
            <Box>
              <ClaimStatus>{claimStatus}</ClaimStatus>
            </Box>
          </Grid2>
          <Grid2 xs={12} md={3}>
            <FormLabel>Created</FormLabel>
            <Box>
              <Typography
                color="common.black"
                fontWeight="bold"
                variant="body2">
                {createdDateTime
                  ? dayjs(createdDateTime).format(DATE_FORMAT.LONG_DATE)
                  : createdDateTime}
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
        {renderReason()}
      </SubSection>

      {Array.isArray(claimData?.claimReviews) &&
        claimData?.claimReviews?.length > 0 && (
          <SubSection>
            <FormLabel error>Review Reason</FormLabel>
            <UnPaginatedList
              items={claimData?.claimReviews?.map(r => ({
                label: r?.reviewReason,
              }))}
            />
          </SubSection>
        )}
    </Stack>
  );
}

export default ClaimDetail;
